import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PreloadAssetService {
    private renderer: Renderer2;
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Preloading_content
    constructor(
        private readonly rendererFactory: RendererFactory2,
        @Inject(DOCUMENT) private readonly document: Document,
    ) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    preload(path: string): void {
        const head = this.document.querySelector('head');
        const extension = this.getExtension(path);

        if (extension) {
            const preloadLink = this.renderer.createElement('link') as HTMLLinkElement;
            this.renderer.setAttribute(preloadLink, 'rel', 'preload');
            this.renderer.setAttribute(preloadLink, 'href', path);

            const as = this.getAsAttribute(extension);
            if (as) {
                this.renderer.setAttribute(preloadLink, 'as', as);
            }

            const type = this.getTypeAttribute(extension);
            if (type) {
                this.renderer.setAttribute(preloadLink, 'type', type);
            }

            this.renderer.appendChild(head, preloadLink);
        }
    }

    private getAsAttribute(extension: string): string | null {
        // TODO extend when necessary
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Preloading_content#What_types_of_content_can_be_preloaded
        switch (extension) {
            case 'json':
                return 'fetch';
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'svg':
                return 'image';
            default:
                return null;
        }
    }

    private getTypeAttribute(extension: string): string | null {
        // TODO extend when necessary
        switch (extension) {
            case 'json':
                return 'application/json';
            case 'jpg':
            case 'jpeg':
                return 'image/jpeg';
            case 'png':
                return 'image/png';
            case 'svg':
                return 'image/svg+xml';
            default:
                return null;
        }
    }

    private getExtension(path: string): string | null {
        if (path) {
            const parts = path.split('.');

            if (parts && parts.length) {
                return parts[parts.length - 1];
            }
        }

        return null;
    }
}
